class PlLocaleMenu extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-hd-locale-toggle]');
    this.panel = this.querySelector('[data-hd-locale-panel]');
    if (!this.toggle || !this.panel) return;

    this.toggle.addEventListener('click', (e) => {
      e.preventDefault();
      this.isOpen() ? this.close() : this.open();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
        this.toggle.focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!this.isOpen()) return;
      if (this.contains(e.target)) return;
      this.close();
    });
  }

  isOpen() {
    return this.panel.getAttribute('data-open') === 'true';
  }

  open() {
    this.panel.setAttribute('data-open', 'true');
    this.panel.removeAttribute('hidden');
    this.toggle.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.panel.removeAttribute('data-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    setTimeout(() => {
      if (!this.isOpen()) this.panel.setAttribute('hidden', '');
    }, 220);
  }
}

if (!customElements.get('pl-locale-menu')) {
  customElements.define('pl-locale-menu', PlLocaleMenu);
}
